import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import Box from 'ui-box';
import { defaultColors, Heading, majorScale } from '../../../npaper';
import { Logo } from '../../Logo';
import { AuthLayout } from '../AuthLayout';

import { animated, useSprings } from 'react-spring';
import { IUser, useStores } from '../../../stores';
import CreateUserStep from './CreateUserStep';
import OrganisationStep from './OrganisationStep';
import ProfileStep from './ProfileStep';

export const AuthSignUp = () => {
  const [step, setStep] = useState(0);

  const history = useHistory();

  const { authStore } = useStores();

  const [user, setUser] = useState<IUser>();

  useEffect(() => {
    if (authStore.isAuthorized) {
      setStep(1);
      let isSub = true;
      authStore.getMe().then((user) => isSub && setUser(user));
      return () => {
        isSub = false;
      };
    }
  }, [authStore, authStore.isAuthorized]);

  const springs = useSprings(
    4,
    new Array(4).fill(0).map((_, i) => ({
      opacity: i === step ? 1 : 0,
      display: i === step ? 'block' : 'none',
      transform: i === step ? 'translateY(0)' : 'translateY(-32px)',
    }))
  );

  return (
    <AuthLayout
      authBannerContent={
        <Box color={defaultColors.brand[100]} paddingX="80px">
          <Box display="flex" alignItems="center" marginBottom={majorScale(4)}>
            <Logo />
            <Heading
              size={400}
              color={defaultColors.brand[100]}
              marginLeft={majorScale(2)}
            >
              sails
            </Heading>
          </Box>
          <Box
            fontWeight="bold"
            fontSize="40px"
            lineHeight="48px"
            marginBottom={majorScale(3)}
          >
            Nothing is impossible; the word itself says, “I’m possible!”
          </Box>
          <Heading
            size={300}
            marginLeft={majorScale(3)}
            color={defaultColors.brand[100]}
          >
            – Audrey Hepburn
          </Heading>
        </Box>
      }
    >
      <animated.div style={springs[0]}>
        <CreateUserStep onCreate={() => setStep(1)} />
      </animated.div>

      <animated.div style={springs[1]}>
        {user && <ProfileStep onUpdate={() => setStep(2)} user={user} />}
      </animated.div>

      <animated.div style={springs[2]}>
        <OrganisationStep
          onUpdate={() => setStep(2)}
          onBack={() => setStep(1)}
        />
      </animated.div>
      <animated.div style={springs[3]}>
        <OrganisationStep
          onUpdate={() => history.push('/')}
          onBack={() => setStep(2)}
        />
      </animated.div>
    </AuthLayout>
  );
};
